module.exports = __webpack_public_path__ + "ffbe64a1f137c05b703aeeee0b7759fb.jpg";